import React, {useState, useRef, useEffect, useCallback} from 'react';
import { StyledLeadContainer } from './Styled';
import LeadAccordion from './LeadAccordion';
import SelectBoxWithLabel from './SelectBoxWithLable';
import TextFiledWithLabel from './TextFieldWithLabel';
import { Box, Button, IconButton, Stack, TextField, Tooltip, CircularProgress} from '@mui/material';
import { useAccordionData } from '../Utility/hooks/useAccordionData';
import DataGridTable from './DataGrid';
import { GridActionsCellItem, GridRowModes } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { ACTIVE_STATUS, allowedLogoTypes, allowedOtherTypes, CHILD_DATAGRIDTABLE_HEIGHT, CLIENT_DT_LOGO, COMMON_DOC_STATUS, handleValidateCodevalue, ROWS_TO_VIEW_IN_CHILD_TABLE } from '../Utility/constant';
import { requestHideLoader, requestShowLoader } from '../Store/Global/action';
import { useSnackbar } from 'notistack';
import CancelIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import tableBodyicon from '../Assets/images/tablebody_edit.png'
import tableEditicon from '../Assets/images/tableheader_edit.png';
import disabledEdit from '../Assets/images/disabled_edit.png';
import DownloadIcon from '@mui/icons-material/Download';
import { getAllDocuments, removeAllDocuments, requestAddDocument, requestUpdateDocument } from '../Store/Documents/action';
import { downloadDocument } from '../Utility/apiHelper';
import { useIsMobile } from '../Utility/hooks/useIsMobile';
import LeadDialog from './LeadDialog';
import AddBoxIcon from '@mui/icons-material/AddBox';

const DocumentManagement = ({disableDownload=true,entityType = "",url,docType,clientId,isViewMode,onSuccess}) => {

    const clientStatusType = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == COMMON_DOC_STATUS)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const [documentDatagridData,setDocumentDatagridData] = useState([]);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const [updateDocumentData,setUpdateDocumentData] = useState();
    const [isFieldDisbale, setFieldDisable] = useState(false);
    const {enqueueSnackbar} = useSnackbar();
    const dispatch = useDispatch();
    const [requiredError, setRequiredError] = useState({
        documentType: false,
    })
    const isMobile = useIsMobile();
    const documentData = useSelector(state=> state?.documents?.documents)
    const handleEditClick = (id,row) => () => {
        setFieldDisable(true)
        setUpdateDocumentData(
          {
            documentType: row?.documentType,
            status : row?.status,
            description :row?.description
          }
        )
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };
        
    const handleSaveClick = (id) => () => {
        setRowModesModel({
              ...rowModesModel,
              [id]: { mode: GridRowModes.View, ignoreModifications: true },
            });
        updateDocument(id);
    };

    const getDocumentsData = useCallback(async() =>{
        dispatch(requestShowLoader())
        const queryparams = {
            params: {
                [entityType] : clientId
            },
        };
        await dispatch(getAllDocuments(queryparams,url))
        dispatch(requestHideLoader())
    }, [clientId, entityType, url, dispatch]);

    const documentAccordion = useAccordionData(
        useCallback(() => {
            if (clientId && entityType && url) {
                return getDocumentsData();
            }
        }, [clientId, entityType, url, getDocumentsData]),
        { refetchOnEveryOpen: true }
    );

    useEffect(()=>{
        return ()=>{
          setDocumentDatagridData([])
          setSelectedDocument([])
          setUpdateDocumentData([])
          dispatch(removeAllDocuments())
        }
    },[])

    useEffect(() => {
  const updatedData = (documentData || []).map((item) => ({ ...item }))
  setDocumentDatagridData(updatedData)
}, [documentData])
    
    const updateDocument = async(id)=>{
      const reqData = {
            ...updateDocumentData,
        }
      if(updateDocumentData?.documentType || updateDocumentData?.status || updateDocumentData?.description){
        const updateUrl = `${url}/${id}`;
        resetAfterUpdate()
      await dispatch(requestUpdateDocument(reqData,updateUrl,enqueueSnackbar,internationalise, onSuccess))
      await getDocumentsData()
      }
      else{
        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"),{variant:"info"})
      }
     }
          const handleCancelClick = (id) => () => {
            setRowModesModel({
              ...rowModesModel,
              [id]: { mode: GridRowModes.View, ignoreModifications: true },
            });
        
            const editedRow = updateDocumentData.find((row) => row.id === id);
            if (editedRow.isNew) {
              setUpdateDocumentData(updateDocumentData.filter((row) => row.id !== id));
            }
          };
    const [selectedDocument,setSelectedDocument] = useState(
        {
            status : "COMMON_DS_ACTIVE"
        }
    );
    
    const handleChange = (event) => {
      const {name, value} = event?.target;

      setUpdateDocumentData({
        ...updateDocumentData,
        [name]: value
      })

    }
    
    const documentColumn = [
      
        {
            field: 'actions',
            type: 'actions',
            headerName: <Tooltip title={handleValidateCodevalue(internationalise,'COMMON_ACTION')} ><img src={tableEditicon} style={{paddingTop: "18px"}} /></Tooltip>,
            width: 100,
            cellClassName: 'actions',
            getActions: (params) => {
              const isInEditMode = rowModesModel[params?.id]?.mode === GridRowModes.Edit;
      
              if (isInEditMode) {
                return [
                  <GridActionsCellItem
                    icon={<Tooltip title={handleValidateCodevalue(internationalise,'COMMON_SAVE')}>
                    <CheckIcon />
                    </Tooltip>}
                    className="textPrimary"
                    disabled = {isViewMode}
                    onClick={handleSaveClick(params?.id)}
                    color="inherit"
                  />,
                  <GridActionsCellItem
                    icon={<Tooltip title={handleValidateCodevalue(internationalise,'COMMON_CANCEL')}>
                    <CancelIcon />
                    </Tooltip>}
                    className="textPrimary"
                    disabled = {isViewMode}
                    onClick={handleCancelClick(params?.id)}
                    color="inherit"
                  />,
                ];
              }
              return [
                <GridActionsCellItem
                icon={<Tooltip title={handleValidateCodevalue(internationalise,'COMMON_DOWNLOAD')}>
                <DownloadIcon />
                </Tooltip>}
                className="textPrimary"
                disabled = {disableDownload && isViewMode}
                onClick={()=>{handleDownloadDoc(params?.row?.documentId)}}
                color="inherit"
                />,
                <GridActionsCellItem
                icon={<Tooltip title={handleValidateCodevalue(internationalise,'COMMON_EDIT')}>
              <img src={isViewMode ? disabledEdit : tableBodyicon} />
                </Tooltip>}
                  className="textPrimary"
                    disabled = {isViewMode}
                  onClick={handleEditClick(params?.id,params?.row)}
                  color="inherit"
                />,
              ];
            },
        },
        {
          field: 'name', 
          headerName: handleValidateCodevalue(internationalise,'COMMON_DOC_NAME'), 
          flex: 1,
        },
        {
                    field: "documentType",
                    headerName: handleValidateCodevalue(internationalise,'COMMON_DOC_TYPE'),
                    flex: 1,
                    editable: isFieldDisbale,
                    renderCell: (cellValues) => <span>
                  {handleValidateCodevalue(internationalise, cellValues?.row?.documentType)}
                  </span>,
                    renderEditCell: (params) => (
                    <SelectBoxWithLabel
                        name="documentType"
                        isStatic={false}
                        ownerdropdown = {false}
                        value={params.value || ""}
                        optionMenuItem={docType}
                        
                        handleOnChange={(e)=>{
                            params.api.setEditCellValue({
                                id: params.id,
                                field: params.field,
                                value: e.target.value,
                            });
                            handleChange(e)}
                        }
                    />
                    )
                },
        {
          field: 'status', 
          headerName: handleValidateCodevalue(internationalise,'COMMON_DOC_STATUS'), 
          flex: 1,
          editable: isFieldDisbale,
          renderCell: (cellValues) => <span>
            {handleValidateCodevalue(internationalise, cellValues?.row?.status)}
            </span>,
                    renderEditCell: (params) => (
                    <SelectBoxWithLabel
                        name="status"
                        isStatic={false}
                        ownerdropdown = {false}
                        value={params.value || ""}
                        optionMenuItem={clientStatusType}
                        
                        handleOnChange={(e)=>{
                            params.api.setEditCellValue({
                                id: params.id,
                                field: params.field,
                                value: e.target.value,
                            });
                            handleChange(e)}
                        }
                    />
                    )
        },
        {
          field: 'description', 
          headerName: handleValidateCodevalue(internationalise,'COMMON_DOC_DESC'), 
          flex: 1,
          editable: isFieldDisbale,
          renderEditCell: (params) => (
            <TextField
            fullWidth
            name="description"
            value={params?.value || ""}
            onChange={(e)=>{
                params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: e.target.value,
                });
                handleChange(e)}
            }
            />
  )
        },
    ]



const handleDownloadDoc = async (documentId) => {
  await downloadDocument(documentId);
};



    const fileInputRef = useRef(null);

   const handleChangeDocument=(event)=>{
   const { name, value, files } = event.target;
  
  if (files && files.length > 0) {
    if(!selectedDocument?.documentType){
    enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_SELECT_DOC_TYPE_FIRST'),{variant:"error"});
    fileInputRef.current.value = "";
    setRequiredError({
        documentType : true
    })
    return;
    }
    const file = files[0];
if (selectedDocument?.documentType === CLIENT_DT_LOGO) {
      if (!allowedLogoTypes.includes(file.type)) {
        enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_LOGO_FORMAT_WARNING'), { variant: "error" });
        fileInputRef.current.value = "";
        return;
      }
    } else {
      if (!allowedOtherTypes.includes(file.type)) {
        enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_DOC_FORMAT_WARNING"), { variant: "error" });
        fileInputRef.current.value = "";
        return;
      }
    }
}
  setSelectedDocument((prev) => ({
    ...prev,
    ...(files && files.length > 0 ? { file: files[0] } : {}), // only set file if files exist
    ...(name ? { [name]: value } : {})                        // only set name/value if name exists
  }));
    }

    const handleUpload =async ()=> {
        dispatch(requestShowLoader());
        if(selectedDocument?.documentType &&selectedDocument?.file){
        const formData = new FormData();
        const {file,...updatedData} = selectedDocument;
        const reqData = {
            ...updatedData,
           [entityType] : clientId,
        }
        formData.append("file", selectedDocument.file);
        formData.append("document", JSON.stringify(reqData));
        handleReset();
        await dispatch(requestAddDocument(formData,url,enqueueSnackbar,internationalise, onSuccess));
        await dispatch(getDocumentsData())
    }
    else {
        
        enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_SELECT_DOC_TYPE_AND_FILE'),{variant:'error'});    
        setRequiredError({
            documentType : true,
        })
    }
    dispatch(requestHideLoader());
    }

    const resetAfterUpdate =()=>{
      setUpdateDocumentData({
         description:"",
      })
    }

    const handleReset =()=>{
        setSelectedDocument({
          ...selectedDocument,
            documentType: "",
            description: "",
            file: null
        })
        if (fileInputRef.current) {
    fileInputRef.current.value = "";
    }
    setRequiredError({
            documentType : false,
        })
    }

  const renderValuesOnCard = [
      { field: "documentType",useLabel:"COMMON_DOC_TYPE" },
      { field: "status",useLabel:"COMMON_DOC_STATUS" },
      { field: "description" ,truncate : "true"}
  ]

const DocUploadForm = (
    <React.Fragment>
                    <SelectBoxWithLabel
                        required = {true}
                        label={handleValidateCodevalue(internationalise,'COMMON_DOC_TYPE')}
                        name="documentType"
                        isStatic={false}
                        style={{width: isMobile ? "100%" : "20%"}}
                        ownerdropdown = {false}
                        value={selectedDocument?.documentType || ""}
                        optionMenuItem={docType}
                        handleOnChange={handleChangeDocument}
                        error={selectedDocument?.documentType ? false : requiredError?.documentType}
                    />
                    <Box
                      className={isMobile ? 'mt-15' : 'ml-20'}
                    >
                    <input 
                        type = "file" 
                        onChange={handleChangeDocument}
                        ref = {fileInputRef}
                    />
                    </Box>

                    <TextFiledWithLabel
                        className={isMobile ? 'mt-15' : ''}
                        name="description"
                        value= {selectedDocument?.description}
                        style={{width: isMobile ? "100%" : "30%"}}
                        label={handleValidateCodevalue(internationalise,'COMMON_DOC_DESC')}
                        handleOnChange={handleChangeDocument}
                    />
    </React.Fragment>
)
const [isOpenDialog,setIsOpenDialog] = useState({
  create : false,
  download : false,
  documentId : ""
})
const handleCloseDialog = () => {
  setIsOpenDialog({
    create : false,
    download : false,
  documentId : ""
  })
}
    return (
        <>

                    <LeadAccordion
                        label={handleValidateCodevalue(internationalise,'COMMON_DOC_SECTION')} 
                        {...documentAccordion.accordionProps}
                    >
                        <React.Fragment>
                    {!isViewMode &&
                    <StyledLeadContainer style={{marginBottom: "20px"}}>
                      {!isMobile &&
                        DocUploadForm
                      }
                    {
                    isMobile ?
                   (
                            <>
                            <Stack
                              className='icon-Container'
                              padding = {"4px 2px"}
                              bgcolor={"#F4F9FE"}
                              display="flex" 
                              gap = {1}
                              justifyContent="center"
                              flexDirection="row" 
                            >
                           <Tooltip
                              title={handleValidateCodevalue(internationalise, 'COMMON_PRODUCT_ADD')}
                              onClick={()=>
                                setIsOpenDialog({
                                  create : true,
                                  download : false
                                })
                              }
                            >
                              <IconButton>
                                <AddBoxIcon className='followup-icons'/>
                              </IconButton>
                            </Tooltip>
                            </Stack>
                            {isOpenDialog?.create && (
                              <LeadDialog
                                open={isOpenDialog?.create}
                                handleClose={handleCloseDialog}
                                title={handleValidateCodevalue(
                                  internationalise,
                                  "COMMON_DOC_SECTION"
                                )}
                                size="sm"
                                btnlabel={handleValidateCodevalue(
                                  internationalise,
                                  "COMMON_DOC_UPLOAD"
                                )}
                                handleSave={() => {
                                  handleUpload();
                                  handleCloseDialog();
                                }}
                              >
                                {DocUploadForm}
                              </LeadDialog>
                            )}
                            {isOpenDialog?.download && (
                              <LeadDialog
                                open={isOpenDialog?.download}
                                handleClose={handleCloseDialog}
                                title={isOpenDialog?.card?.name}
                                size="sm"
                                btnlabel={ handleValidateCodevalue(
                                  internationalise,
                                  "COMMON_DOWNLOAD"
                                ) }
                                handleSave={()=>handleDownloadDoc(isOpenDialog?.documentId)}
                              >
                                <Box
                                  display={"flex"} 
                                  justifyContent="center" 
                                  flexDirection={"column"}
                                  gap = {"12px"}
                                >
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_DOC_TYPE')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.documentType)}
                                />
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_DOC_STATUS')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.status)}
                                />
                                <TextFiledWithLabel
                                  sx = {{width: "100% !important"}}
                                  disabled = {true}
                                  label={handleValidateCodevalue(internationalise,'COMMON_DOC_DESC')}
                                  value={handleValidateCodevalue(internationalise,isOpenDialog?.card?.description)}
                                />
                                </Box>
                              </LeadDialog>
                            )}
                            </>
                          )
                    :
                     <Button className='biztantu-sec-btn' variant="contained" size="large" name="docbtn" onClick={handleUpload}>{handleValidateCodevalue(internationalise,'COMMON_DOC_UPLOAD')}</Button>
                    }
                      </StyledLeadContainer>
                    }
                    <DataGridTable 
                        showName = {"name"}
                        renderValuesOnCard={renderValuesOnCard}
                        handleOnClickCard = {(card)=>setIsOpenDialog({
                          create : false,
                          download : true,
                          card : card,
                          documentId : card?.documentId
                        })}
                        showId = {false}
                        columns ={documentColumn}
                        dataGridData = {documentDatagridData || []}
                        isLoading={false}
                        isRequiredToolBar={false}
                        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                        height = {CHILD_DATAGRIDTABLE_HEIGHT}
                        isCheckboxReq = {false}
                        rowModesModel={rowModesModel}
    
                    />
                        </React.Fragment>
                </LeadAccordion>
                
       
        </>
    )
}

export default DocumentManagement;